import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "lib/redux/store";

export interface ScoreState {
  maxTotalScore: number;
  maxOverAllScore: number;
  maxSectionalScore: number;
  maxCoreSectionScore: number;
  maxNonCoreSectionScore: number;
  coreSections: {
    projectsMaxScore: number;
    experienceMaxScore: number;
    educationMaxScore: number;
    skillsMaxScore: number;
    personalDetailsMaxScore: number;
  };
  nonCoreSections: {
    certificatesMaxScore: number;
    awardsMaxScore: number;
    languagesMaxScore: number;
    customSectionMaxScore: number;
  };
}

export const initialScoreState = {
  maxTotalScore: 100,
  contentDensityScore: 10, // 10% of maxTotalScore
  maxSectionalScore: 90, // 90% of maxTotalScore
  maxCoreSectionScore: 0,
  maxNonCoreSectionScore: 0,
  coreSections: {
    projectsMaxScore: 0,
    experienceMaxScore: 0,
    educationMaxScore: 0,
    skillsMaxScore: 0,
    personalDetailsMaxScore: 0,
  },
  nonCoreSections: {
    certificatesMaxScore: 0,
    awardsMaxScore: 0,
    languagesMaxScore: 0,
    customSectionMaxScore: 0,
  },
};

export const scoringSlice = createSlice({
  name: "scoring",
  initialState: initialScoreState,
  reducers: {
    // @ts-ignore: Unreachable code error
    setScoring: (state, action: PayloadAction<ScoreState>) => {
      return action.payload;
    },
    setSkillMaxScore: (state, action: PayloadAction<number>) => {
      state.coreSections.skillsMaxScore = action.payload;
    },
  },
});

export const { setScoring, setSkillMaxScore } = scoringSlice.actions;

// export scoring settings

export const selectScoring = (state: RootState) => state.scoring;

export default scoringSlice.reducer;
